import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { ReportSkeletonComponent } from './ReportSkeleton.component';

@NgModule({
    imports: [
        CommonModule,
        CoreUiModule // OldIconModule (needed if this goes in core ui)
    ],
    declarations: [ReportSkeletonComponent],
    exports: [ReportSkeletonComponent],
    providers: []
})
export class ReportSkeletonModule {}
